export const convertMDLink = (str: string) => {
  return str.replace(/\[([^\[]+)\]\((https:\/\/[^\s]+)\)/g, '<a href="$2" target="_blank">$1</a>');
};
